<template>
  <div
    class="panel-wrapper"
    :style="computedStyle"
    :class="{
      'bg-surface': !dark,
      'bg-black': dark,
      absolute: !relative,
      floating: float,
    }"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Panel',
  props: {
    grow: Boolean,
    float: Boolean,
    relative: Boolean,
    height: {
      type: [String, Number],
    },
    dark: Boolean,
  },
  computed: {
    computedStyle() {
      const height = typeof this.height === 'string' ? this.height : `${this.height}px`;
      return { height, minHeight: height };
    },
  },
};
</script>

<style lang="scss" scoped>
.panel-wrapper {
  @apply mx-auto w-full relative bottom-0;
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
  transition: height 0.3s ease-out;
  overflow: auto;
  max-height: 97%;

  &.absolute {
    @apply absolute left-0 right-0;
  }

  @screen md {
    border-top-left-radius: 50px;
    border-top-right-radius: 50px;
    max-height: 768px;
  }

  @screen lg {
    max-height: 900px;
  }
  &.floating {
    box-shadow: 0 0 20px 0 rgba(78, 78, 78, 0.5);
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  }
}
</style>
